import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import classNames from 'classnames/bind';
import Heading from 'components/shared/heading';
import AppButton from 'components/shared/app-button';

import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

import cardApp from './svg/card-app.svg';
import shape from './svg/shape.svg';
import styles from './download-application.module.scss';

const cx = classNames.bind(styles);

const DownloadApplication = () => {
  const {
    wpSharedBlock: {
      acf: { title },
    },
    wp: {
      globalFields: {
        acf: { appStoreUrl, googlePlayUrl },
      },
    },
    phone,
    cardMan,
  } = useStaticQuery(
    graphql`
      query {
        wpSharedBlock(slug: { eq: "download-application" }) {
          acf {
            title
          }
        }
        wp {
          globalFields {
            acf {
              appStoreUrl
              googlePlayUrl
            }
          }
        }
        cardMan: file(relativePath: { eq: "home/download-application/card-man.png" }) {
          childImageSharp {
            gatsbyImageData(width: 310)
          }
        }
        phone: file(relativePath: { eq: "home/download-application/phone.png" }) {
          childImageSharp {
            gatsbyImageData(width: 300)
          }
        }
      }
    `
  );

  const cardAnimationVariants = {
    initial: {
      opacity: 0,
      scale: 0.83,
      y: -23,
    },
    appear: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.3, ease: [0.21, 0.49, 0.33, 1], delay: 0.2 },
    },
  };

  const cardManAnimationVariants = {
    initial: {
      opacity: 0,
      scale: 0.83,
      x: -100,
    },
    appear: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: { duration: 0.3, ease: [0.21, 0.49, 0.33, 1], delay: 0.4 },
    },
  };

  const [sectionRef, inView] = useInView({ threshold: 0.4, triggerOnce: true });

  return (
    <section ref={sectionRef} className={cx('wrapper')}>
      <div className="container">
        <div className={cx('columns', 'inner')}>
          <div className="column is-6-tablet is-offset-1-widescreen">
            <Heading className={cx('title')} tag="h2">
              {title}
            </Heading>

            <div className={cx('buttons')}>
              <AppButton type="appStore" href={appStoreUrl} />
              <AppButton type="googlePlay" href={googlePlayUrl} />
            </div>
          </div>

          <div className={cx('column', 'right')}>
            <motion.div className={cx('illustration')} animate={inView ? 'appear' : 'initial'}>
              <img className={cx('shape')} src={shape} alt="" />
              <GatsbyImage className={cx('phone')} image={getImage(phone)} alt="" />
              <motion.img
                variants={cardAnimationVariants}
                className={cx('card-app')}
                src={cardApp}
                alt=""
              />
              <motion.div variants={cardManAnimationVariants} className={cx('card-man')}>
                <GatsbyImage image={getImage(cardMan)} alt="" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadApplication;
